export const centerNode = (node, padding = 16) => {
    let rect = node.getBoundingClientRect();
    const width = rect.right - rect.left;
    const screenWidth = window.screen.width;

    if (width + padding * 2 > screenWidth) {
        node.style.width = screenWidth - padding * 2 + "px";
        rect = node.getBoundingClientRect();
    }

    const offsetRight = rect.right + padding - screenWidth;
    const offsetLeft = rect.left - padding;

    if (offsetRight > 0) {
        node.style.transform = `translateX(${-offsetRight}px)`;
        //node.style.transform = `translateX(calc(-50% - ${offsetRight}px))`;
    } else if (offsetLeft < 0) {
        node.style.transform = `translateX(${-offsetLeft}px)`;
        //node.style.transform = `translateX(calc(-50% - ${offsetLeft}px))`;
    }
};

export const getBoundingRelativeRect = (childNode, parentNode) => {
    if (!childNode || !parentNode) {
        return null;
    }

    const parentPos = parentNode.getBoundingClientRect();
    const childPos = childNode.getBoundingClientRect();

    return {
        top: childPos.top - parentPos.top,
        right: childPos.right - parentPos.right,
        bottom: childPos.bottom - parentPos.bottom,
        left: childPos.left - parentPos.left,
    };
};
